import * as React from 'react';
import { CheckIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';

/** General workspace settings (placeholder form). */
export function SettingsGeneralPage() {
  const [saved, setSaved] = React.useState(false);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Workspace</CardTitle>
        <CardDescription>
          Placeholder form — wire it to a real endpoint by adding it to the OpenAPI spec first.
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4 sm:max-w-md">
        <div className="grid gap-2">
          <Label htmlFor="workspace-name">Workspace name</Label>
          <Input id="workspace-name" defaultValue="CDF Template" />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="workspace-description">Description</Label>
          <Textarea
            id="workspace-description"
            defaultValue="Black & white baseline template for CDF projects."
            rows={3}
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="workspace-region">Region</Label>
          <Select defaultValue="australiaeast">
            <SelectTrigger id="workspace-region" className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="australiaeast">Australia East</SelectItem>
              <SelectItem value="westeurope">West Europe</SelectItem>
              <SelectItem value="eastus2">East US 2</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
      <CardFooter className="gap-2">
        <Button
          onClick={() => {
            setSaved(true);
            window.setTimeout(() => setSaved(false), 2000);
          }}
        >
          {saved ? <CheckIcon /> : null}
          {saved ? 'Saved' : 'Save changes'}
        </Button>
        <Button variant="ghost">Reset</Button>
      </CardFooter>
    </Card>
  );
}
